module.exports = __webpack_public_path__ + "img/BOSdynamics5.a833662e.jpg";